import { menuTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';

export const handleRoute = (
  history: any,
  url: menuTypes.MenuTypesType,
  params?: Record<string, string>,
  states?: Record<any, any>,
) => {
  if (params && states) {
    return history.push({ pathname: url, search: urlHelper.addQueryParameters(params, ''), state: states });
  }
  if (params) {
    return history.push({ pathname: url, search: urlHelper.addQueryParameters(params, '') });
  }
  if (states) {
    return history.push({ pathname: url, state: states });
  }

  return history.push(url);
};
